import { Tabs } from "antd";
import Layout from "./Layout";
import DashboardIntegrated from "./DashboardIntegrated";
import DashboardIndividual from "./DashboardIndividual";
import "./DashboardPage.css";

const DashboardPage = () => (
  <Layout>
    <div className="dashboard-page">
      <div className="card-section">
        <div className="section-title">운영 성과 대시보드</div>
        <Tabs
          className="dashboard-tabs"
          items={[
            { key: "integrated", label: "통합", children: <DashboardIntegrated /> },
            { key: "individual", label: "단지별", children: <DashboardIndividual /> },
          ]}
        />
      </div>
    </div>
  </Layout>
);

export default DashboardPage;
